import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Expertise from "./Pages/Expertise";
import Innovation from "./Pages/Innovation";
import Activities from "./Pages/Activities";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
import Gallery from "./Pages/Gallery";
import Book from "./Pages/Book";
import Published from "./Pages/Published";
import Waiting from "./Pages/Waiting";
import B1 from "./Blog/B1";  // <-- FIXED
import B2 from "./Blog/B2";  // <-- FIXED
import B3 from "./Blog/B3";  // <-- FIXED
import B4 from "./Blog/B4";  // <-- FIXED
import B5 from "./Blog/B5";  // <-- FIXED
import B6 from "./Blog/B6";  // <-- FIXED
import B7 from "./Blog/B7";  // <-- FIXED
import B8 from "./Blog/B8";  // <-- FIXED
import B9 from "./Blog/B9";  // <-- FIXED
import B10 from "./Blog/B10";  // <-- FIXED
import B11 from "./Blog/B11";  // <-- FIXED
import B12 from "./Blog/B12";  // <-- FIXED
import B13 from "./Blog/B13";  // <-- FIXED
import B14 from "./Blog/B14";  // <-- FIXED
import B15 from "./Blog/B15";  // <-- FIXED
import B16 from "./Blog/B16";  // <-- FIXED
import B17 from "./Blog/B17";  // <-- FIXED
import B18 from "./Blog/B18";  // <-- FIXED
import Detail from "./Blog/Detail";










import Wishlist from "./Pages/Wishlist";
import Cart from "./Pages/Cart";
import Team from "./Pages/Team";
import Login from "./Components/Login";
import AdminLayout from "./Admin/AdminLayout";
import AdminDashboard from "./Admin/AdminDashboard";
import AdminAddBlog from "./Admin/AdminAddBlog";
import AdminViewBlogs from "./Admin/AdminViewBlogs";
import AdminSeoFiles from "./Admin/AdminSeoFiles";
import AdminSeoMeta from "./Admin/AdminSeoMeta";
import AdminLogin from "./Admin/Login";
import RequireAdminAuth from "./Admin/RequireAdminAuth";
import { AdminAuthProvider } from "./Admin/AdminAuth";
import SeoManager from "./SeoManager";
import GaManager from "./GaManager";
import AdminAnalytics from "./Admin/AdminAnalytics";
import { appBasename } from "./config/api";

import { CartProvider } from "./Context/CartContext";

function App() {
  return (
    <BrowserRouter basename={appBasename()}>
          <AdminAuthProvider>
        <CartProvider>
          <SeoManager />
          <GaManager />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/B1" element={<B1 />} />   
                    <Route path="/B2" element={<B2 />} />   
          <Route path="/B3" element={<B3 />} />   {/* <-- FIXED */}
          <Route path="/B4" element={<B4 />} />   {/* <-- FIXED */}
          <Route path="/B5" element={<B5 />} />   {/* <-- FIXED */}
          <Route path="/B6" element={<B6 />} />   {/* <-- FIXED */}
          <Route path="/B7" element={<B7 />} />   {/* <-- FIXED */}
          <Route path="/B8" element={<B8 />} />   {/* <-- FIXED */}
          <Route path="/B9" element={<B9 />} />   {/* <-- FIXED */}
          <Route path="/B10" element={<B10 />} />   {/* <-- FIXED */}
          <Route path="/B11" element={<B11 />} />   {/* <-- FIXED */}
          <Route path="/B12" element={<B12 />} />   {/* <-- FIXED */}
          <Route path="/B13" element={<B13 />} />   {/* <-- FIXED */}
          <Route path="/B14" element={<B14 />} />   {/* <-- FIXED */}
          <Route path="/B15" element={<B15 />} />   {/* <-- FIXED */}
          <Route path="/B16" element={<B16 />} />   {/* <-- FIXED */}
          <Route path="/B17" element={<B17 />} />   {/* <-- FIXED */}
          <Route path="/B18" element={<B18 />} />   {/* <-- FIXED */}
                    <Route path="/Detail" element={<Detail />} />   {/* <-- FIXED */}
          











          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdminAuth>
                <AdminLayout />
              </RequireAdminAuth>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="add-blog" element={<AdminAddBlog />} />
            <Route path="view-blogs" element={<AdminViewBlogs />} />
            <Route path="seo-files" element={<AdminSeoFiles />} />
            <Route path="seo-meta" element={<AdminSeoMeta />} />
            <Route path="analytics" element={<AdminAnalytics />} />
          </Route>

          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/team" element={<Team />} />
          <Route path="/book" element={<Book />} />
          <Route path="/published" element={<Published />} />
          <Route path="/waiting" element={<Waiting />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </CartProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
